import React, { useState } from 'react';
import PaymentModal from './PaymentModal';
import CustomButton from '../Button/CustomButton';
import AddIcon from '../CustomSVGIcons/AddIcon';
import { strings } from '../../constants/strings';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { Box } from '@mui/material';

interface IAddCard {}

const SimpleAddCardModal: React.FC<IAddCard> = () => {
    const [open, setOpen] = useState(false);
    const { themeStyle } = useThemeContext();

    return (
        <Box mt={2}>
            <PaymentModal onClose={() => setOpen(!open)} open={open} amount={100} />
            <CustomButton
                label={strings.add_new_card}
                onClick={() => setOpen(!open)}
                withIcon
                customIcon={
                    <AddIcon
                        style={{ marginLeft: '4px' }}
                        height={'20px'}
                        width={'20px'}
                        fill={theme[themeStyle].zeus_dark}
                    />
                }
            />
        </Box>
    );
};

export { SimpleAddCardModal };
